import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { translateFieldError } from '../../types';
import translate from '../../utils/utils';
export const useTranslatedOptionEnum = (prefix, enumList, namespace) => {
    const { t } = useTranslation(namespace, { keyPrefix: prefix });
    return useMemo(() => enumList.map((s) => (_jsx("option", { value: s, children: t(s) }, s))), [enumList, t]);
};
const SelectInput = forwardRef(({ id, error, label, errorParams, options, hasEmptyValue = false, disableEmptyValue = false, ...otherProps }, ref) => {
    const { t } = useTranslation('shared');
    const errorMessage = translateFieldError(t, error);
    return (_jsxs("div", { className: `control-group ${error && 'error'}`, children: [_jsx("label", { htmlFor: id, children: translate(label) }), _jsx("div", { className: `dropdown-wrap ${error && 'error'}`, children: _jsxs("select", { id: id, ...otherProps, ref: ref, children: [hasEmptyValue && (_jsx("option", { value: "", disabled: disableEmptyValue, children: ' ' })), options] }) }), error && _jsx("p", { className: "error-message", children: errorMessage })] }));
});
SelectInput.displayName = 'SelectInput';
export default SelectInput;
